import { addBreadcrumb } from "@sentry/react";

import { TransferScreen } from "./Types";

export function logNavigation(screen: TransferScreen) {
  addBreadcrumb({ message: `Navigate to ${screen.screen}` });
}
